/**
 * ConnectorLine Component - MA-ARCH-164
 * 
 * Renders a bezier curve connector between funnel nodes.
 * Extracted from FunnelVisualization.jsx.
 */

import React from 'react';

/**
 * ConnectorLine - Renders a curved connector between nodes.
 * 
 * @param {Object} props
 * @param {number} props.startX - Starting X coordinate
 * @param {number} props.startY - Starting Y coordinate
 * @param {number} props.endX - Ending X coordinate
 * @param {number} props.endY - Ending Y coordinate
 * @param {boolean} props.isHighlighted - Whether edge is highlighted (selected/hovered source)
 * @param {boolean} props.isHovered - Whether source node is hovered
 */
export function ConnectorLine({ startX, startY, endX, endY, isHighlighted, isHovered }) {
  const deltaY = endY - startY;
  const deltaX = endX - startX;
  
  const verticalClearance = Math.max(15, Math.min(deltaY * 0.3, 35));
  const cp1Y = startY + verticalClearance;
  const cp2Y = endY - verticalClearance;
  
  const horizontalBias = Math.sign(deltaX) * Math.min(Math.abs(deltaX) * 0.2, 35);
  
  const path = `M ${startX} ${startY} 
                C ${startX + horizontalBias} ${cp1Y}, 
                  ${endX - horizontalBias} ${cp2Y}, 
                  ${endX} ${endY}`;
  
  const isActive = isHighlighted || isHovered;
  
  return (
    <>
      {isActive && (
        <path
          d={path}
          fill="none"
          stroke="#6366f1"
          strokeWidth={6}
          strokeLinecap="round"
          opacity={0.15}
          className="transition-all duration-200 ease-out"
        />
      )}
      <path
        d={path}
        fill="none"
        stroke={isActive ? '#818cf8' : '#64748b'}
        strokeWidth={isActive ? 2 : 1.5}
        strokeLinecap="round"
        opacity={isActive ? 1 : 0.5}
        className="transition-all duration-200 ease-out"
      />
    </>
  );
}

export default ConnectorLine;
